import { DecisionKindEnum } from "@/enum/decision-kind";
import { formatToBRL } from "@/utils/formatToMoney";

import { FIRST_INSTALLMENT_INDEX, MIN_INSTALLMENTS } from "../constants";
import { divideInstallments } from "../installments";
import { PAYROLL_VOUCHER_LABELS } from "../messages";
import { PayrollVoucher } from "../types";

export const installmentsOf = (voucher: PayrollVoucher): number =>
  voucher.installments_count ?? MIN_INSTALLMENTS;

export const installmentAmountsOf = (voucher: PayrollVoucher): number[] =>
  divideInstallments(voucher.amount, installmentsOf(voucher));

const approvalConsequence = (voucher: PayrollVoucher): string =>
  PAYROLL_VOUCHER_LABELS.CONSEQUENCE_APPROVE(
    installmentsOf(voucher),
    formatToBRL(
      Math.abs(installmentAmountsOf(voucher)[FIRST_INSTALLMENT_INDEX] ?? 0),
    ),
  );

const CONSEQUENCES: Record<DecisionKindEnum, (voucher: PayrollVoucher) => string> =
  {
    [DecisionKindEnum.APPROVE]: approvalConsequence,
    [DecisionKindEnum.REJECT]: (): string =>
      PAYROLL_VOUCHER_LABELS.CONSEQUENCE_REJECT,
  };

export const consequenceOf = (
  kind: DecisionKindEnum,
  voucher: PayrollVoucher,
): string => CONSEQUENCES[kind](voucher);
